import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {
  Label,
  Grid,
  Icon,
  Table,
  Card,
  Input,
  Popup,
  Dropdown,
  Loader,
} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import './providersList.scss';

class ProvidersList extends Component {
  constructor(props) {
    super(props);
    this.onPageClick = this.onPageClick.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.Providers, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.changeProviderTextFilter('');
    this.props.changeProvidersListPage(0);
    this.props.loadProviders();
  }

  onFilterChange(event) {
    this.props.changeProviderTextFilter(event.target.value);
    this.props.filterProviders(event.target.value);
  }

  onPageClick(value) {
    this.props.changeProvidersListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeProvidersListPageSize(data.value);
  }

  render() {
    const {filterText} = this.props;
    return (
      <div className='providers-list'>
        <Card raised fluid className='provider-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2>Mantenimiento de Proveedores</h2>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange.bind(this)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='16' textAlign='left' >
                <label>
                  <strong>Opciones de Configuración:</strong>
                </label>
                {this.renderTrackingConfigOption()}
                {this.renderAmountControlOption()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card fluid raised>
          {this.renderProvidersTable()}
        </Card>
      </div>
    );
  }

  renderProvidersTable() {
    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Origen</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Nombre proveedor
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Order Cycle Manual
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Order Cycle Calculado
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderLoaderOrProviders()}</Table.Body>
        {this.renderPagination()}
      </Table>
    );
  }

  renderLoaderOrProviders() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderProviders();
  }

  renderProviders() {
    const {providers} = this.props;
    return providers.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.origin}</Table.Cell>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.manualOrderCycle || 0}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCycle || 0}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Link to={`/proveedores/ver/${element.code}`}>
                  <Icon name='eye' size='large' />
                </Link>
              }
              content='Ver'
              position='top center'
              inverted
            />
            {this.renderEditOption(element.code)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTrackingConfigOption() {
    if (!hasAccessPermission(this.props.permissions, resources.Providers, scopes.Edit)) {
      return null;
    }
    return (
      <Label as={Link} to={paths.ProviderOrdersTrackingConfig}>
        <Icon name='settings' size='large' />
        Tracking de Pedidos
      </Label>
    );
  }

  renderAmountControlOption() {
    if (!hasAccessPermission(this.props.permissions, resources.ProviderOrdersAmountLimits, scopes.Edit)) {
      return null;
    }
    return (
      <Label as={Link} to={paths.ProviderOrdersAmountControl}>
        <Icon name='settings' size='large' />
        Control de Montos en Pedidos
      </Label>
    );
  }

  renderEditOption(code) {
    if (!hasAccessPermission(this.props.permissions, resources.Providers, scopes.Edit)) {
      return null;
    }
    return (
      <Popup
        trigger={
          <Link to={`/proveedores/editar/${code}`}>
            <Icon name='write' size='large' />
          </Link>
        }
        content='Editar'
        position='top center'
        inverted
      />
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.provider.loading,
    'providers': state.provider.page,
    'filterText': state.provider.filterText,
    'pageNumber': state.provider.pageNumber,
    'pageSize': state.provider.pageSize,
    'totalItems': state.provider.filteredList.length,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  loadProviders,
  filterProviders,
  changeProviderTextFilter,
  changeProvidersListPage,
  changeProvidersListPageSize,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  loadProviders,
  filterProviders,
  changeProviderTextFilter,
  changeProvidersListPage,
  changeProvidersListPageSize,
  navigateTo,
})(ProvidersList);
